import APIService from '../api';

export class SortController {
  field = '';
  order = 'ASC';

  update(field: string) {
    if (field !== this.field) {
      this.order = 'ASC';
    }
    this.field = field;
    this.order = this.order === 'ASC' ? 'DESC' : 'ASC';
  }

  toString() {
    return `${this.field}:${this.order}`;
  }

  toQueryParams() {
    return {
      sortBy: this.field,
      sortOrder: this.order
    };
  }
}
export class Pagination extends APIService {
  private items: any[] = [];
  private path?: string = '';
  private query?: Record<string, any>;
  private firstLoad = true;
  private loading = false;
  private debounce: any;
  private formatRow: any = (data: any) => data;

  constructor(formatRow?: any) {
    super();
    if (formatRow) {
      this.formatRow = formatRow;
    }
  }

  async refresh(path: string, query?: Record<string, any>, delay = 0) {
    if (this.debounce) clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.path = path;
      this.query = query;
      this.items = [];
      this.next();
    }, delay);
  }

  async next() {
    if (!this.path || this.loading) {
      return;
    }
    try {
      this.loading = true;
      const { data } = await this.get(this.path, {
        params: this.query
      });
      const formattedData = data.items.map((data: any) => this.formatRow(data));
      this.items = [...this.items, ...formattedData];
      this.path = data.links.next;
      this.query = undefined;
    } catch (e) {
      this.path = undefined;
      this.query = undefined;
      console.error(e);
    } finally {
      this.loading = false;
      this.firstLoad = false;
    }
  }

  hasNext() {
    return !!this.path;
  }

  getItems() {
    return this.items;
  }

  isEmpty() {
    return this.items.length === 0;
  }

  isLoading() {
    return this.firstLoad || this.loading;
  }

  setPaginationTarget(target: HTMLElement) {
    const observer = new IntersectionObserver(async entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.hasNext()) {
          this.next();
        }
      });
    });

    if (target) {
      observer.observe(target);
    }
  }
}
